module.exports = function getResource(label, vars = []) {
    const resources = {
        ccReward: 'Récompense pour les cartes de crédit*',
        exp: 'Exp.'
    };

    return resources[label];
};
